module.exports = __webpack_public_path__ + "media/customize/banner-classic-top-2054f25d.svg";